"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _base = _interopRequireDefault(require("./base"));
var _utils = require("../utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` [Legacy] The DerivativeService, is used to fetch project related data.
 *
 * Check DS wiki for more details
 * https://wiki.autodesk.com/display/saascore/Derivative+Service+REST+API+V2
 *
 * @deprecated
 *   The service is deprecated as the acmSessionId is to be retired.
 *   Switch to use DerivativeService if you're trying to get thumbnails or manifest data.
 *   Check https://wiki.autodesk.com/display/R13N/Race+to+AUS%3A+ACM+Namespace
 */
var DerivativeService = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function DerivativeService(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, DerivativeService);
    _this = _callSuper(this, DerivativeService, [sdk]);
    _this.dsEndpoint_v2 = sdk.Config.getEnv('DS_V2');
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(DerivativeService, _Base);
  return (0, _createClass2["default"])(DerivativeService, [{
    key: "setScopes",
    value:
    /**
     * Setup acm scopes
     */
    function setScopes(scopes) {
      this.acmScopes = scopes;
    }

    /**
     * get manifest
     *
     * @param bubbleUrn - The bubble urn
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     */
  }, {
    key: "getManifest",
    value: function getManifest(bubbleUrn, options) {
      return this.getManifestBubble(bubbleUrn, '', options);
    }

    /**
     * get all manifests
     *
     * @param bubbleUrn - The bubble urn
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     */
  }, {
    key: "getManifestAll",
    value: function getManifestAll(bubbleUrn, options) {
      return this.getManifestBubble(bubbleUrn, '/all', options);
    }

    /**
     * manifest bubble status
     *
     * @param urn - The bubble urn
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     */
  }, {
    key: "getStatus",
    value: function getStatus(urn, options) {
      return this.getManifestBubble(urn, '/status', options);
    }

    /**
     * This API streams back the default thumbnail content (PNGs) of a given file/mime type directly.
     *
     * @param fileType - The file type, for example: dwf, dwg, f3d, and etc.
     * @param type - type of the requested thumbnail, one of 'small', 'medium' or 'large'.
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     */
  }, {
    key: "getDefaultThumbnail",
    value: function getDefaultThumbnail(fileType, type, options) {
      var url = this.dsEndpoint_v2 + '/thumbnails/fileType/' + fileType + '?type=' + type;
      if (options !== null && options !== void 0 && options.acmSessionId) {
        url = "".concat(url, "&acmsession=").concat(options.acmSessionId);
      }
      return this.getManifestThumbnail(url);
    }

    /**
     * Get thumbnail content
     *
     * @param urn - The bubble urn
     * @param guid - The guid
     * @param role - THe resource role with one of value 'extracted' or 'rendered'
     * @param type - type of the requested thumbnail, one of 'small', 'medium' or 'large'.
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     *
     * @returns the thumbnail stream data by the file urn, and the specified sheet guid.
     */
  }, {
    key: "getThumbnail",
    value: function getThumbnail(urn, guid, role, type, options) {
      var url = this.getThumbnailUrl(urn, guid, role, (0, _extends2["default"])({}, options, {
        type: type
      }));
      return this.getManifestThumbnail(url);
    }

    /**
     * @param fileType - The file type, for example: dwf, dwg, f3d, and etc.
     * @param width - The width
     * @param height - The height
     * @param options - Additional options with the shape of \{ type: 'small', acmSessionId: 'XXXXXX' \}
     *
     * @returns default thumbnail url
     */
  }, {
    key: "getDefaultThumbnailUrl",
    value: function getDefaultThumbnailUrl(fileType, width, height, options) {
      var query;
      if (width && height) {
        query = "width=".concat(width, "&height=").concat(height);
      } else if (options !== null && options !== void 0 && options.type) {
        query = "type=".concat(options.type);
      }
      if (options !== null && options !== void 0 && options.acmSessionId) {
        query = query ? "".concat(query, "&acmsession=").concat(options.acmSessionId) : "acmsession=".concat(options.acmSessionId);
      } else {
        console.warn('[SDK] Docs.getDefaultThumbnailUrl acmSessionId missed inside options!');
      }
      var url = this.dsEndpoint_v2 + '/thumbnails/fileType/' + fileType;
      return query ? "".concat(url, "?").concat(query) : url;
    }

    /**
     * Generate thumbnail url
     *
     * @param urn - The resource urn.
     * @param guid - The resource guid
     * @param role - THe resource role with one of value 'extracted' or 'rendered'
     * @param options - The parameter to setup the size of the thumbnail, possible values
     *                       With object value like \{ width: 100, height: 100, type: 'small', acmSessionId: 'XXXXXX' \}
     *                       With string value like 'small', 'medium', 'large'
     * @returns The thumbnail url like https://developer-stg.api.autodesk.com/derivativeservice/v2/thumbnails/dXJuOmFkc2sud2lwZGF0YTp2ZXJzaW9uZWRGaWxlOk5SbkVmdXBDUjhTMldLVFVTRlhtMVE_dmVyc2lvbj0y?type=small
     */
  }, {
    key: "getThumbnailUrl",
    value: function getThumbnailUrl(urn, guid, role, options) {
      var url = this.dsEndpoint_v2 + '/thumbnails/' + _utils.Base64.encode(urn);
      var params = options || {};
      var _ref = (0, _typeof2["default"])(params) === 'object' ? params : {
          type: params,
          acmSessionId: undefined,
          width: undefined,
          height: undefined
        },
        width = _ref.width,
        height = _ref.height,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'small' : _ref$type,
        acmSessionId = _ref.acmSessionId;

      // Prefer to use specified width and height first.
      if (width && height) {
        url = "".concat(url, "?width=").concat(width, "&height=").concat(height);
      } else {
        url = "".concat(url, "?type=").concat(type);
      }
      if (guid) {
        url = "".concat(url, "&guid=").concat(guid);
      }
      if (role && ['extracted', 'rendered'].includes(role)) {
        url = "".concat(url, "&role=").concat(role);
      }
      if (acmSessionId) {
        url = "".concat(url, "&acmsession=").concat(acmSessionId);
      } else {
        console.warn('[SDK] Docs.getThumbnailUrl acmSessionId missed inside options!');
      }
      return url;
    }

    /**
     * content url
     *
     * @param urn - The resource urn.
     * @param acmSessionId - The acm session id.
     */
  }, {
    key: "getContentUrl",
    value: function getContentUrl(urn, acmSessionId) {
      var url = this.dsEndpoint_v2 + '/derivatives/' + encodeURIComponent(urn);
      if (acmSessionId) {
        url = "".concat(url, "?acmsession=").concat(acmSessionId);
      } else {
        console.warn('[SDK] Docs.getContentUrl acmSessionId missed!');
      }
      return url;
    }

    /**
     * content data
     *
     * @param urn - The resource urn.
     * @param acmSessionId - The acm session id.
     */
  }, {
    key: "getContentData",
    value: function getContentData(urn, acmSessionId) {
      var headers = {
        'x-ads-acm-check-groups': 'true'
      };
      this.acmScopes && (headers['x-ads-acm-scopes'] = this.acmScopes);
      var url = this.getContentUrl(urn, acmSessionId);
      return this.HttpService.apigee.get(url, {
        headers: headers,
        responseType: 'blob'
      });
    }

    /**
     * manifest bubble
     *
     * @param bubbleUrn - The resource urn.
     * @param method - The request resource method. Could be '', `/all` or `/status`
     * @param options - Additional options with the shape of \{ acmSessionId: 'XXXXXX' \}
     */
  }, {
    key: "getManifestBubble",
    value: function getManifestBubble(bubbleUrn) {
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var options = arguments.length > 2 ? arguments[2] : undefined;
      var headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'x-ads-acm-check-groups': 'true'
      };
      this.acmScopes && (headers['x-ads-acm-scopes'] = this.acmScopes);
      var url = this.dsEndpoint_v2 + '/manifest/' + _utils.Base64.encode(bubbleUrn) + method;
      if (options !== null && options !== void 0 && options.acmSessionId) {
        url = "".concat(url, "?acmsession=").concat(options.acmSessionId);
      } else {
        console.warn("[SDK] Docs.getManifestBubble acmsession missed!");
      }
      return this.HttpService.apigee.get(url, {
        headers: headers
      });
    }

    /**
     * Get manifest thumbnail
     *
     * @param url - The resource url.
     */
  }, {
    key: "getManifestThumbnail",
    value: function getManifestThumbnail(url) {
      var headers = {
        'Content-Type': 'application/img',
        'x-ads-acm-check-groups': 'true'
      };
      this.acmScopes && (headers['x-ads-acm-scopes'] = this.acmScopes);
      if (!(url !== null && url !== void 0 && url.includes('acmsession='))) console.warn("[SDK] Docs.getManifestThumbnail acmsession missed at url ".concat(url, "!"));
      return this.HttpService.apigee.get(url, {
        headers: headers
      });
    }

    /**
     * supported v2
     */
  }, {
    key: "getSupported",
    value: function getSupported() {
      var supportedUrl = this.dsEndpoint_v2 + '/supported';
      return this.HttpService.apigee.get(supportedUrl);
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'DS';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = DerivativeService;